package com.essntl.uikit.components.pdfviewer

actual class PdfViewerState actual constructor(url: String) {
    actual var byteArray: ByteArray = byteArrayOf()
        private set

    actual var isLoading: Boolean = false
        private set

    actual var isFailure: Boolean = false
        private set
}